<template>
  <b-modal
      title="ویرایش پلی‌لیست"
      id="modal-edit-playlist"
      hide-footer
      header-bg-variant="light"
      @hidden="resetForm"
      @ok="submit"
  >
    <b-form @submit.prevent="submit">
      <b-form-group label="عنوان" label-for="title">
        <b-form-input
            id="title"
            v-model="form.title"
            placeholder="مثلاً فصل اول"
            required
        />
      </b-form-group>

      <b-form-group label="توضیحات" label-for="description">
        <b-form-textarea
            id="description"
            v-model="form.description"
            placeholder="توضیحات این فصل"
            rows="3"
        />
      </b-form-group>

      <b-form-group label="ترتیب" label-for="sortOrder">
        <b-form-input
            id="sortOrder"
            v-model="form.sortOrder"
            type="number"
            placeholder="۰"
        />
      </b-form-group>

      <b-form-group>
        <b-form-checkbox v-model="form.isActive" switch>
          فعال
        </b-form-checkbox>
      </b-form-group>

      <div class="d-flex justify-content-end gap-2">
        <b-button variant="primary" type="submit" class="ml-2" :disabled="submitting">
          <i class="fas fa-spinner fa-spin" v-if="submitting"></i>
          ذخیره
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { BModal, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BButton } from 'bootstrap-vue'
import { PlaylistUpdateRequest } from '@/libs/Api/Playlist'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  name: 'EditPlaylistModal',
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BButton
  },
  props: {
    playlist: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      visible: false,
      submitting: false,
      form: {
        title: '',
        description: '',
        sortOrder: 0,
        isActive: true
      }
    }
  },
  watch: {
    playlist: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.form.title = newVal.title || ''
          this.form.description = newVal.description || ''
          this.form.sortOrder = newVal.sortOrder || 0
          this.form.isActive = newVal.isActive !== undefined ? newVal.isActive : true
        }
      }
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    hide() {
      this.visible = false
    },
    resetForm() {
      if (this.playlist) {
        this.form.title = this.playlist.title || ''
        this.form.description = this.playlist.description || ''
        this.form.sortOrder = this.playlist.sortOrder || 0
        this.form.isActive = this.playlist.isActive !== undefined ? this.playlist.isActive : true
      }
      this.submitting = false
    },
    submit() {
      if (!this.form.title.trim()) {
        this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: 'خطا',
            icon: 'XIcon',
            variant: 'warning',
            text: 'لطفاً عنوان را وارد کنید.'
          }
        })
        return
      }

      if (!this.playlist) return

      this.submitting = true
      const data = {
        playlistId: this.playlist.id,
        title: this.form.title,
        description: this.form.description,
        sortOrder: parseInt(this.form.sortOrder) || 0,
        isActive: this.form.isActive
      }

      const request = new PlaylistUpdateRequest(this)
      request.setParams(data)
      request.fetch(
          (content) => {
            this.submitting = false
            this.hide()
            this.$toast({
              component: ToastificationContent,
              position: 'bottom-center',
              props: {
                title: 'موفق',
                icon: 'CheckIcon',
                variant: 'success',
                text: 'پلی‌لیست با موفقیت بروزرسانی شد.'
              }
            })
            this.$emit('updated', content)
            this.$bvModal.hide('modal-edit-playlist')

            this.resetForm()
          },
          (error) => {
            this.submitting = false
            this.$toast({
              component: ToastificationContent,
              position: 'bottom-center',
              props: {
                title: 'خطا',
                icon: 'XIcon',
                variant: 'danger',
                text: error.message || 'مشکل در بروزرسانی پلی‌لیست'
              }
            })
          }
      )
    }
  }
}
</script>
